import type { JurisdictionCoverage } from '@mollusk/shared';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

/** Drill-down for a single permitting jurisdiction (data already loaded). */
export function JurisdictionDetailPanel({
  jurisdiction,
  onClose,
}: {
  jurisdiction: JurisdictionCoverage | null;
  onClose: () => void;
}) {
  const j = jurisdiction;
  return (
    <Dialog open={j !== null} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{j ? `${j.place_name}, ${j.state}` : 'Jurisdiction'}</DialogTitle>
      <DialogContent dividers>
        {j ? (
          <Stack spacing={2}>
            <Box>
              <Typography variant="h5">{j.permit_count.toLocaleString()}</Typography>
              <Typography variant="body2" color="text.secondary">
                permits on record
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary">
              Last refreshed: {j.last_refresh ?? 'unknown'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Min permit date: {j.min_permit_date ?? 'unknown'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Min continuous permit date: {j.min_continuous_date ?? 'unknown'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Max continuous permit date: {j.last_refresh ?? 'unknown'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Distinct addresses:{' '}
              {j.distinct_addresses != null ? j.distinct_addresses.toLocaleString() : 'unknown'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Distinct lat/lng coordinates:{' '}
              {j.distinct_coords != null ? j.distinct_coords.toLocaleString() : 'unknown'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Population covered: {j.population.toLocaleString()}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Census BPS new-permit volume: {j.bps_volume.toLocaleString()} units/yr
            </Typography>
          </Stack>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
